import * as Preact from "preact"

import "./Dice.less"
import DiceFace from "./DiceFace.jsx"
import ItemBreakdown from "./ItemBreakdown.jsx"
import Unit from "@fae/source/models/Unit.js"

const MOUSE_BUTTON = 2

export default class Dice {
    render() {
        let {item, isAnimated, isHighlighted, isLabeled, includeDescription, anchored, index} = this.props
        if(item === undefined) return
        if(item === null) {
            return (
                <div class="Null Dice">
                    <div class="DiceFace"/>
                </div>
            )
        }

        const power = Unit.power({"stage": this.props.stage, "unit": this.props.unit, "item": this.props.item})

        return (
            <div class="Dice" isPressed={this.isPressed} anchored={anchored || (index % 2 == 0 ? "top" : "bottom") || "top"} index={index} isLabeled={isLabeled} isAnimated={isAnimated} isHighlighted={isHighlighted}
                onMouseDown={this.onMouseDown()} onMouseUp={this.onMouseUp()} onMouseOut={this.onMouseOut()} onMouseOver={this.onMouseOver()} onContextMenu={this.onContextMenu()} onClick={this.props.onClick}>
                <div class="Label">
                    <div class="Title"><span>{item.title || "???"}</span></div>
                </div>
                <ItemBreakdown item={item} unit={this.props.unit} stage={this.props.stage}/>
                <DiceFace item={item} unit={this.props.unit} stage={this.props.stage}/>
            </div>
        )
    }
    onMouseDown() {
        return (event) => {
            if(this.props.onMouseDown instanceof Function) this.props.onMouseDown(event)
            if(event.button != MOUSE_BUTTON) return
            // event.stopPropagation()
            if(this.isPressed != true) {
                this.isPressed = true

                window.hasRightClicked = true
            }
        }
    }
    onMouseUp() {
        return (event) => {
            if(this.props.onMouseUp instanceof Function) this.props.onMouseUp(event)
            if(event.button != MOUSE_BUTTON) return
            // event.stopPropagation()
            // window.hasRightClicked = true
            this.isPressed = false
        }
    }
    onMouseOut() {
        return (event) => {
            // event.stopPropagation()
            // window.hasRightClicked = true
            this.isPressed = false
        }
    }
    onMouseOver() {
        return (event) => {
            if(event.button != MOUSE_BUTTON && event.buttons != MOUSE_BUTTON) return
            // event.stopPropagation()
            if(this.isPressed != true) {
                this.isPressed = true

                window.hasRightClicked = true
                if(this.hasBeenCounted != true) {
                    this.hasBeenCounted = true
                    window.hasRightClickedCount = window.hasRightClickedCount || 0
                    window.hasRightClickedCount += 1
                }
            }
        }
    }
    onContextMenu() {
        return (event) => {
            window.tutorial.hasDismissedRightClickToLearnMore = true
            event.preventDefault()
            event.stopPropagation()
        }
    }
}
